import React, {
  createContext,
  useContext,
  useEffect,
  useState
} from "react";

import { Notification } from "../Types/Notification";
import { getAllNotificationByUser } from "../../Notification/Service/NotificationService";
import { storage } from "../Utils/authStorage";

// Import notification API

interface NotificationContextType {
  notifications: Notification[];
  addNotification: (
    notification: Notification
  ) => void;
  markAsRead: (id: number) => void;
}

const NotificationContext =
  createContext<NotificationContextType | null>(
    null
  );


// export const NotificationProvider = ({
//   children
// }: {
//   children: React.ReactNode;
// }) => {
  export const NotificationProvider = ({
    children,
    authReady
  }: {
    children: React.ReactNode;
    authReady: boolean;
  }) => {

  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [loaded, setLoaded] = useState(false);


  /**
   * Load existing notifications from DB
   * Runs once when application starts
   */
  const loadNotifications = async () => {

    console.log("CALLING NOTIFICATION API");
  
    try {
  
      const response = await getAllNotificationByUser();
  
      console.log("SUCCESS");
  
      setNotifications(response.data);
  
    } catch (error) {
  
      console.log("ERROR", error);
  
    }
  
  };

  /**
   * Load notifications on page refresh/login
   */
  useEffect(() => {

    const handleLogin = () => {
  
      console.log(
        "LOGIN EVENT RECEIVED"
      );
  
      loadNotifications();
    };
  
    window.addEventListener(
      "auth-login",
      handleLogin
    );
  
    return () =>
      window.removeEventListener(
        "auth-login",
        handleLogin
      );
  
  }, []);

  /**
   * Real-time notifications from WebSocket
   */
  const addNotification = (
    notification: Notification
  ) => {

    console.log(
      "ADDING NOTIFICATION:",
      notification
    );

    setNotifications(prev => [
      notification,
      ...prev
    ]);
  };

  /**
   * Mark notification as read
   */
  const markAsRead = (id: number) => {

    setNotifications(prev =>
      prev.map(n =>
        n.id === id
          ? { ...n, read: true }
          : n
      )
    );

  };

  return (
    <NotificationContext.Provider
      value={{
        notifications,
        addNotification,
        markAsRead
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationContext =
  () => {

    const context = useContext(
      NotificationContext
    );

    if (!context) {
      throw new Error(
        "NotificationContext missing"
      );
    }

    return context;
  };